import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { getInfoToDisplayImageDeviation } from './_helpers';
import Unknown from '../Unknown';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import { useLazyLoading } from '../../../LazyLoadingImage/useLazyLoading';
import { isValidFileSrc } from '../../_helpers';
import s from './Image.scss';
/**
 * If you are changing any fundamentals here please remember to also
 * consider the DaEditorWrappers image views, they use this to generate
 * HTML and react version of editor text.
 */ const ImageDumbView = (props)=>{
    const { deviation , className , width: propsWidth , height: propsHeight , allowPreviewUsage =true , useBackgroundColor =true , greenLikeCrop , noCropping , extraWrapStyles , 'aria-hidden': ariaHidden  } = props;
    const { ref , inView , enableLazyLoading , supportsNativeLazy  } = useLazyLoading(true);
    if (!propsWidth && !propsHeight) {
        // no use-cases for responsive image views
        ddt.warn('deviationviews', 'Deviation image is not rendered because of missing Width and Height properties');
        return null;
    }
    const info = getInfoToDisplayImageDeviation({
        deviation,
        height: propsHeight,
        width: propsWidth,
        allowPreviewUsage,
        greenLikeCrop,
        noCropping
    });
    if (!info || !info.pickedImage || !isValidFileSrc(info.pickedImage.src)) {
        ddt.warn('deviationviews', 'Could not find a suitable image file to render deviation image', info);
        return /*#__PURE__*/ React.createElement(Unknown, _extends({}, props));
    }
    const { height , width , imgStyles , pickedImage  } = info;
    ddt.log('deviationviews.thumbtype', `Used ${pickedImage.type}`);
    const imageProps = {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    };
    const wrapStyles = _object_spread_props(_object_spread({}, extraWrapStyles), {
        width,
        height
    });
    const imageStyles = _object_spread({
        width,
        height
    }, imgStyles);
    // Native lazy loading is simple
    if (enableLazyLoading && supportsNativeLazy) {
        imageProps.loading = 'lazy';
        imageProps.src = pickedImage.src;
    }
    // Intersection Observer lazy loading
    if (enableLazyLoading && !supportsNativeLazy) {
        if (inView) {
            imageProps.src = pickedImage.src;
        }
    }
    // Standard non lazy loaded
    if (!enableLazyLoading) {
        imageProps.src = pickedImage.src;
    }
    if (pickedImage.srcSet) {
        imageProps.srcSet = pickedImage.srcSet;
    }
    // Some cache debugging TODO remove later
    const checkImgs = {
        '329444453:350T': 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/f0b54843-a4a5-49ef-9f81-35d75c7a1c1d/d5g54yt-60aaea32-ead2-44de-b1ab-a0697599bf5e.jpg/v1/fill/w_526,h_350,q_70,strp/untitled_by_muteor_d5g54yt-350t.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NjgyIiwicGF0aCI6IlwvZlwvZjBiNTQ4NDMtYTRhNS00OWVmLTlmODEtMzVkNzVjN2ExYzFkXC9kNWc1NHl0LTYwYWFlYTMyLWVhZDItNDRkZS1iMWFiLWEwNjk3NTk5YmY1ZS5qcGciLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.oQfgYlYFgPSoqMdpknFAu6hQ_aC2du6zGsF-JTlSXXs',
        '934449023:250T': 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/401ee429-4a2d-4990-ac80-109dae9ef848/dfgchhb-8df656cd-3062-4de9-93e1-1eac5efdeb9a.jpg/v1/fill/w_444,h_250,q_70,strp/sacred_northern_california_by_imaginenkh_dfgchhb-250t.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjI1MiIsInBhdGgiOiJcL2ZcLzQwMWVlNDI5LTRhMmQtNDk5MC1hYzgwLTEwOWRhZTllZjg0OFwvZGZnY2hoYi04ZGY2NTZjZC0zMDYyLTRkZTktOTNlMS0xZWFjNWVmZGViOWEuanBnIiwid2lkdGgiOiI8PTQwMDAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.uPyKcIAX3dywcoDW4OzR9igNPdSs0nAo_Mj1HT5YscY',
        '937280362:350T': 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/fd0061d6-5321-42b9-92f1-6674494e6693/dfi165m-6755c4e3-d86e-4b9a-84e7-f73ffd208e7e.jpg/v1/fill/w_495,h_350,q_70,strp/rico__megaman_x_dive__by_parororo_dfi165m-350t.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTI4MCIsInBhdGgiOiJcL2ZcL2ZkMDA2MWQ2LTUzMjEtNDJiOS05MmYxLTY2NzQ0OTRlNjY5M1wvZGZpMTY1bS02NzU1YzRlMy1kODZlLTRiOWEtODRlNy1mNzNmZmQyMDhlN2UuanBnIiwid2lkdGgiOiI8PTE4MTAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.rq0gOqmG0j9unPH4bZqAU1f59LJoBtWwhL1yFHT-XxU',
        '913116668:350T': 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/aea046b5-589a-463d-9119-f40d956640f2/df3n9bw-6547c535-646d-4088-a016-83142352b01a.jpg/v1/fill/w_622,h_350,q_70,strp/neon_butterfly___photoshop_art_by_phaserunner_df3n9bw-350t.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6IlwvZlwvYWVhMDQ2YjUtNTg5YS00NjNkLTkxMTktZjQwZDk1NjY0MGYyXC9kZjNuOWJ3LTY1NDdjNTM1LTY0NmQtNDA4OC1hMDE2LTgzMTQyMzUyYjAxYS5qcGciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.WxGr6J6rjmkitExONyW5RVcPv5WcSNiIDYF-qj-1y4Y'
    };
    if (pickedImage.src && checkImgs[`${deviation.deviationId}:${pickedImage.type.toUpperCase()}`]) {
        if (pickedImage.src !== checkImgs[`${deviation.deviationId}:${pickedImage.type.toUpperCase()}`]) {
            ddt.alert('deviation', 'Thumb url got changed', [
                'debug'
            ], {
                pickedImage,
                checked: checkImgs[`${deviation.deviationId}:${pickedImage.type.toUpperCase()}`]
            });
        }
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: enableLazyLoading && !supportsNativeLazy ? ref : undefined,
        className: classnames(s['wrapper'], className, !useBackgroundColor && s['no-background']),
        style: wrapStyles,
        "aria-hidden": ariaHidden
    }, renderDebug(info.pickedImage, propsWidth, propsHeight, enableLazyLoading), /*#__PURE__*/ React.createElement("img", _extends({
        alt: deviation.title,
        style: imageStyles
    }, imageProps)), enableLazyLoading && !supportsNativeLazy && /*#__PURE__*/ React.createElement("noscript", null, /*#__PURE__*/ React.createElement("img", {
        alt: deviation.title,
        src: pickedImage.src,
        srcSet: pickedImage.srcSet,
        style: imageStyles
    })));
};
ImageDumbView.displayName = 'ImageDumbView';
function renderDebug(pickedImage, propsWidth, propsHeight, isLazy) {
    return /*#__PURE__*/ React.createElement(Flag, {
        condition: "thumbdebug"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['thumb-debug']
    }, isLazy && 'lazy/', pickedImage.type, "/", pickedImage.src.replace(/\?.*/, '').split('.').pop(), "/", pickedImage.transparency === true ? 'true' : 'false', "/", /*#__PURE__*/ React.createElement("abbr", {
        title: "imageDims"
    }, pickedImage.width, "x", pickedImage.height), "/", /*#__PURE__*/ React.createElement("abbr", {
        title: "blockDims"
    }, propsWidth, "x", propsHeight)));
}
export default ImageDumbView;
